import { useState } from "react";

export const useData = (props = {}) => {
	const { defaultData, defaultStatus, defaultError } = props;
	const [data, setData] = useState(defaultData || null); // values should be [idle, loading, error, success]
	const [status, setStatus] = useState(defaultStatus || "idle"); // values should be [idle, loading, error, success]
	const [error, setError] = useState(defaultError || null);

	return { data, setData, status, setStatus, error, setError };
};
